<label class="p1">
    <ng-content></ng-content>
</label>
